const config = {
    localAuth: {
        apiServiceUrl: process.env.REACT_APP_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_HOST:process.env.REACT_APP_API_HOST,
        apiServiceUrl2: process.env.REACT_APP_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_HOST:process.env.REACT_APP_API_HOST_2,
    },
    // defaultLang: process.env.REACT_APP_DEFAULT_LANG,
    storageKey: {
        loginKey: 'chatToken',
        userAccDetails:'chatAdmin'
    },
    tokenRefreshTime: 6*24*60*60, //if it is more than 6 days, need to refresh app to log in
    version: process.env.REACT_APP_VERSION,
    sendPanelHeight: 80,
    optionPanelHeight: 192,
    headerHeight: 64,
    typingLatency: 1500
}


export default config
